import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right-arrow",
  "use": "icon-right-arrow-usage",
  "viewBox": "0 0 13 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 23\" id=\"icon-right-arrow\"><path d=\"M12.262 10.622L1.974.338a1.159 1.159 0 0 0-1.635 0 1.153 1.153 0 0 0 0 1.632l9.472 9.468L.34 20.907a1.154 1.154 0 0 0 0 1.633c.451.45 1.184.45 1.635 0l10.288-10.285a1.165 1.165 0 0 0-.001-1.633z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol